/**
 * Require terms checkbox before cart checkout (drawer + cart page).
 * Error note only appears when checkout is attempted without ticking.
 */
function initCartCheckoutTerms(root = document) {
  root.querySelectorAll('[data-cart-terms-notice]').forEach((notice) => {
    if (notice.dataset.termsBound === 'true') return;
    notice.dataset.termsBound = 'true';

    const checkbox = notice.querySelector('[data-cart-terms-checkbox]');
    const errorEl = notice.querySelector('[data-cart-terms-error]');
    const form = notice.closest('form');
    if (!checkbox || !form) return;

    const hideError = () => {
      if (errorEl) errorEl.hidden = true;
    };

    const showError = () => {
      if (errorEl) errorEl.hidden = false;
    };

    hideError();

    checkbox.addEventListener('change', () => {
      if (checkbox.checked) hideError();
    });

    form.addEventListener('submit', (event) => {
      if (!checkbox.checked) {
        event.preventDefault();
        showError();
        checkbox.focus();
      }
    });

    form.addEventListener(
      'click',
      (event) => {
        const target = event.target.closest(
          '#checkoutButton, button[name="checkout"], input[name="checkout"]'
        );
        if (!target || checkbox.checked) return;
        event.preventDefault();
        showError();
        checkbox.focus();
      },
      true
    );
  });
}

document.addEventListener('DOMContentLoaded', () => initCartCheckoutTerms());
document.addEventListener('cart-drawer:refreshed', () => initCartCheckoutTerms());
